
export function trans(lang, obj) {
  if (obj == null) return '';
  if (!obj[lang]) {
    return obj['en'] || obj['hr'] || '';
  } else {
    return obj[lang];
  }
}

export function setState(component, field) {
  return value => { component.setState({[field]: value}) };
}

